/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ area: "abdomen" | "back" | "chest" | "legs" | "lower_back" | "shoulders" }} Today_Checkin_Area_InInputs */

const en_us2_today_checkin_area_in = /** @type {(inputs: Today_Checkin_Area_InInputs) => LocalizedString} */ (i) => {
	if (i?.area === "chest") return /** @type {LocalizedString} */ (`in my chest`);
	if (i?.area === "back") return /** @type {LocalizedString} */ (`in my back`);
	if (i?.area === "lower_back") return /** @type {LocalizedString} */ (`in my lower back`);
	if (i?.area === "shoulders") return /** @type {LocalizedString} */ (`in my shoulders`);
	if (i?.area === "legs") return /** @type {LocalizedString} */ (`in my legs`);
	if (i?.area === "abdomen") return /** @type {LocalizedString} */ (`in my abs`);
	return /** @type {LocalizedString} */ ("today.checkin_area_in");
};

const pt_br2_today_checkin_area_in = /** @type {(inputs: Today_Checkin_Area_InInputs) => LocalizedString} */ (i) => {
	if (i?.area === "chest") return /** @type {LocalizedString} */ (`no peito`);
	if (i?.area === "back") return /** @type {LocalizedString} */ (`nas costas`);
	if (i?.area === "lower_back") return /** @type {LocalizedString} */ (`na lombar`);
	if (i?.area === "shoulders") return /** @type {LocalizedString} */ (`nos ombros`);
	if (i?.area === "legs") return /** @type {LocalizedString} */ (`nas pernas`);
	if (i?.area === "abdomen") return /** @type {LocalizedString} */ (`no abdômen`);
	return /** @type {LocalizedString} */ ("today.checkin_area_in");
};

const es_419_today_checkin_area_in = /** @type {(inputs: Today_Checkin_Area_InInputs) => LocalizedString} */ (i) => {
	if (i?.area === "chest") return /** @type {LocalizedString} */ (`en el pecho`);
	if (i?.area === "back") return /** @type {LocalizedString} */ (`en la espalda`);
	if (i?.area === "lower_back") return /** @type {LocalizedString} */ (`en la zona lumbar`);
	if (i?.area === "shoulders") return /** @type {LocalizedString} */ (`en los hombros`);
	if (i?.area === "legs") return /** @type {LocalizedString} */ (`en las piernas`);
	if (i?.area === "abdomen") return /** @type {LocalizedString} */ (`en el abdomen`);
	return /** @type {LocalizedString} */ ("today.checkin_area_in");
};

const pt_pt2_today_checkin_area_in = /** @type {(inputs: Today_Checkin_Area_InInputs) => LocalizedString} */ (i) => {
	if (i?.area === "chest") return /** @type {LocalizedString} */ (`no peito`);
	if (i?.area === "back") return /** @type {LocalizedString} */ (`nas costas`);
	if (i?.area === "lower_back") return /** @type {LocalizedString} */ (`na lombar`);
	if (i?.area === "shoulders") return /** @type {LocalizedString} */ (`nos ombros`);
	if (i?.area === "legs") return /** @type {LocalizedString} */ (`nas pernas`);
	if (i?.area === "abdomen") return /** @type {LocalizedString} */ (`no abdómen`);
	return /** @type {LocalizedString} */ ("today.checkin_area_in");
};

const fr_fr2_today_checkin_area_in = /** @type {(inputs: Today_Checkin_Area_InInputs) => LocalizedString} */ (i) => {
	if (i?.area === "chest") return /** @type {LocalizedString} */ (`aux pectoraux`);
	if (i?.area === "back") return /** @type {LocalizedString} */ (`au dos`);
	if (i?.area === "lower_back") return /** @type {LocalizedString} */ (`au bas du dos`);
	if (i?.area === "shoulders") return /** @type {LocalizedString} */ (`aux épaules`);
	if (i?.area === "legs") return /** @type {LocalizedString} */ (`aux jambes`);
	if (i?.area === "abdomen") return /** @type {LocalizedString} */ (`aux abdos`);
	return /** @type {LocalizedString} */ ("today.checkin_area_in");
};

const de_de2_today_checkin_area_in = /** @type {(inputs: Today_Checkin_Area_InInputs) => LocalizedString} */ (i) => {
	if (i?.area === "chest") return /** @type {LocalizedString} */ (`in der Brust`);
	if (i?.area === "back") return /** @type {LocalizedString} */ (`im Rücken`);
	if (i?.area === "lower_back") return /** @type {LocalizedString} */ (`im unteren Rücken`);
	if (i?.area === "shoulders") return /** @type {LocalizedString} */ (`in den Schultern`);
	if (i?.area === "legs") return /** @type {LocalizedString} */ (`in den Beinen`);
	if (i?.area === "abdomen") return /** @type {LocalizedString} */ (`im Bauch`);
	return /** @type {LocalizedString} */ ("today.checkin_area_in");
};

const it_it2_today_checkin_area_in = /** @type {(inputs: Today_Checkin_Area_InInputs) => LocalizedString} */ (i) => {
	if (i?.area === "chest") return /** @type {LocalizedString} */ (`al petto`);
	if (i?.area === "back") return /** @type {LocalizedString} */ (`alla schiena`);
	if (i?.area === "lower_back") return /** @type {LocalizedString} */ (`nella zona lombare`);
	if (i?.area === "shoulders") return /** @type {LocalizedString} */ (`alle spalle`);
	if (i?.area === "legs") return /** @type {LocalizedString} */ (`alle gambe`);
	if (i?.area === "abdomen") return /** @type {LocalizedString} */ (`all'addome`);
	return /** @type {LocalizedString} */ ("today.checkin_area_in");
};

/**
* | area | output |
* | --- | --- |
* | "chest" | "in my chest" |
* | "back" | "in my back" |
* | "lower_back" | "in my lower back" |
* | "shoulders" | "in my shoulders" |
* | "legs" | "in my legs" |
* | "abdomen" | "in my abs" |
*
* @param {Today_Checkin_Area_InInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_checkin_area_in = /** @type {((inputs: Today_Checkin_Area_InInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_Checkin_Area_InInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_checkin_area_in(inputs)
	if (locale === "es-419") return es_419_today_checkin_area_in(inputs)
	if (locale === "pt-PT") return pt_pt2_today_checkin_area_in(inputs)
	if (locale === "fr-FR") return fr_fr2_today_checkin_area_in(inputs)
	if (locale === "de-DE") return de_de2_today_checkin_area_in(inputs)
	if (locale === "it-IT") return it_it2_today_checkin_area_in(inputs)
	return en_us2_today_checkin_area_in(inputs)
});
export { today_checkin_area_in as "today.checkin_area_in" }